module.exports = __webpack_public_path__ + "img/pexels-steven-arenas-379419.3495223c.jpg";